
import { Observable } from 'rxjs';
import { Parameter } from '../common/parameter';

export interface ModulemasterParameter extends Parameter {
    searchTerm: number;
    orderBy: string;  
}

export interface Modulemaster {

  id?: number;
  name: string;
    
  parameters?: ModulemasterParameter[];
  links?: any;
}


export abstract class ModulemasterData {

    abstract list(): Observable<Modulemaster[]>;
    abstract create(url: string,data: Modulemaster): Observable<any>;
    abstract update(url: string,data: Modulemaster): Observable<any>;
    abstract delete(url: string): Observable<any>;

  }
